import { Button, ButtonProps } from '../buttons/Button';

import styles from './ActionButtons.module.scss';

export function ActionButtons({ buttons }: { buttons: ButtonProps[] }) {
  return (
    <div className={styles['root']}>
      {buttons.map((button, index) => (
        <Button key={`${button.title ?? 'action'}-${index}`} {...button}>
          {button.title}
        </Button>
      ))}
    </div>
  );
}
